module.exports = __webpack_public_path__ + "static/media/sell-product1.f7c6db6e.png";